module.exports = __webpack_public_path__ + "static/media/sprites_2x.0fc49f76.png";